import api from "../../config/client.axios.api";

export const createStoreApi = async (infoCreate: any) => {
  const response = await api.post(`/store`, infoCreate);
  return response.data;
};
